import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import Env from 'root/lib/Env';

import a11yPrototypeReducer from './a11y_prototype/redux/a11yPrototypeReducer';
import allAboardReducer from './allAboard/redux/allAboardReducer';
import appSessionReducer from './reducers/appSessionReducer';
import assignmentLinkReducer from './hub/reducers/assignmentLinkReducer';
import becauseThisThatReducer from './becauseThisThat/reducers/becauseThisThatReducer';
import bestBuddy from './bestBuddy/redux/bestBuddyReducer';
import bigIdeaReducer from './whatsTheBigIdea/redux/whatsTheBigIdeaReducer';
import blendingReducer from './blending/redux/reducers/blendingReducer';
import bookClubReducer from './bookClub/redux/bookClubReducer';
import boostFluencyReducer from './boostFluency/redux/boostFluencyReducer';
import captions from './reducers/captions';
import cartoonFactoryReducer from './cartoonFactory/redux/cartoonFactoryReducer';
import cityPlannerReducer from './cityPlanner/redux/cityPlannerReducer';
import codexReducer from './codex/redux/codexReducer';
import connectItReducer from './connectIt/redux/reducers';
import curiosoCallingReducer from './curiosoCalling/redux/curiosoCallingReducer';
import curiosoCrossingReducer from './curiosoCrossing/redux/curiosoCrossingReducer';
import curiosoReducer from './hub/reducers/curiosoReducer';
import curiousCases from './curious_cases/redux/curiousCasesReducer';
import curriculumsReducer from './hub/reducers/curriculumsReducer';
import cutItOutReducer from './cutItOut/redux/store';
import debateABall from './debateABall/redux/debateABallReducer';
import directorsCutReducer from './directorsCut/redux/directorsCutReducer';
import doubleTroubleReducer from './doubleTrouble/redux/doubleTroubleReducer';
import eReader from './eReader/redux/eReaderReducer';
import estaOAquellaReducer from './estaOAquella/redux/estaOAquellaReducer';
import featureToggleReducer from './reducers/featureToggleReducer';
import fieldObserver from './field_observer/redux/fieldObserverReducer';
import fluencyReducer from './fluency/redux/fluencyReducer';
import foodTruckCombinedReducers from './foodTruck/foodTruckStore';
import fotoFotoCognado from './fotoFotoCognado/redux/fotoFotoCognadoReducer';
import gameHeaderReducer from './components/GameHeader/redux/gameHeaderReducer';
import gemNyeFriendsReducer from './gemNyeFriends/redux/gemNyeFriendsReducer';
import globalErrorReducer from './components/GlobalErrorHandler/globalErrorReducer';
import goblinGourmet from './goblinGourmet/goblinGourmetStore';
import grumpyGoblinsReducer from './grumpyGoblins/redux/grumpyGoblinsReducer';
import hangryGoblinsReducer from './hangryGoblins/redux/reducers';
import idiomaticaReducer from './idiomatica/redux/idiomaticaReducer';
import inkBlottJrReducer from './inkBlottJr/redux/inkBlottJrReducer';
import itemsReducer from './hub/reducers/itemsReducer';
import juegaYConjugaReducer from './juegaYConjuga/redux/juegaYConjugaReducer';
import laRanaBrincacharcos from './laRanaBrincacharcos/redux/laRanaBrincacharcosReducer';
import letterSoundCorrecpondencesReducer from './letterSoundCorrespondences/redux/reducers/correspondenceReducer';
import liveRegionReducer from './components/LiveRegion/redux/liveRegionReducer';
import mapReducer from './hub/reducers/mapReducer';
import messageInABottleReducer from './messageInABottle/redux/messageInABottleReducer';
import metaGameReducer from './hub/reducers/metaGameReducer';
import mindTheGapReducer from './mindTheGap/store';
import modalSystemReducer from './hub/reducers/modalSystemReducer';
import newGameReducer from './newGame/redux/newGameReducer';
import newsFlashReducer from './newsflash/redux/newsflashReducer';
import notebookReducer from './hub/reducers/notebookReducer';
import parrotTheaterReducer from './parrotTheater/redux/parrotTheaterReducer';
import persistStateReducer from './reducers/persistStateReducer';
import persistTestReducer from './persistTest/persistTestReducer';
import pickyGoblinsReducer from './pickyGoblins/redux/pickyGoblinsReducer';
import pictureThisReducer from './pictureThis/redux/reducers';
import placementTool from './placementTool/redux/reducers/placementReducer';
import planTorres from './planTorres/redux/planTorresReducer';
import poetsPathReducer from './poetsPath/redux/poetsPathReducer';
import powerReducer from './hub/reducers/powerReducer';
import progressScreenReducer from './reducers/progressScreenReducer';
import punchlineReducers from './punchline/redux/punchlineReducers';
import questNavigationReducer from './hub/reducers/questNavigationReducer';
import questWorkflowReducer from './hub/reducers/questWorkflowReducer';
import readAllAboutIt from './readAllAboutIt/redux/readAllReducer';
import realWordReadingReducer from './realWordReading/redux/reducers/realWordReadingReducer';
import rhymeTimeReducer from './rhymeTime/redux/store';
import robovoicePrototypeReducer from './robovoice_prototype/redux/robovoicePrototypeReducer';
import robovoiceReducer from '../lib/robovoice/lib/robovoiceReducer';
import segmentingReducer from './segmenting/redux/reducers/segmentingReducer';
import selectedActivityReducer from './reducers/selectedActivityReducer';
import shadesOfMeaningReducer from './shadesOfMeaning/shadesOfMeaningReducer';
import showOffReducer from './showOff/showOffReducer';
import silabalonLaCopaReducer from './silabalonLaCopa/redux/reducers';
import silabalonReducer from './silabalon/redux/silabalonReducer';
import skillScan from './skillScan/redux/skillScanReducer';
import sloppyScrollsCombinedReducers from './sloppyScrolls/sloppyScrollsStore';
import sortingReducer from './sortItOut/redux/sortingReducer';
import stickerBookReducer from './stickerBook/redux/stickerBookReducer';
import storyboardReducer from './storyboard/redux/store';
import storyboxReducer from './storybox/redux/storyboxReducer';
import studentProgressReducer from './hub/reducers/studentProgressReducer';
import superMatchReducer from './superMatch/store';
import syllableDecodingReducer from './syllableDecoding/redux/reducers/syllableDecodingReducer';
import tfeReducer from './hub/reducers/tfeReducer';
import tongueTwistReducer from './tongueTwist/redux/store';
import tubeTalesReducer from './tubeTales/redux/tubeTalesReducer';
import unmaskThatCombinedReducers from './unmaskThat/unmaskThatStore';
import usageReducer from './reducers/usageReducer';
import wildPlanetReducer from './wildPlanet/redux/wildPlanetReducer';
import wordbotsReducers from './wordbots/wordbotsReducers';
import wordCity from './wordCity/redux/wordCityReducer';
import wordRaidersReducer from './wordRaiders/redux/wordRaidersReducer';
import wordSlideReducer from './wordSlide/redux/wordSlideReducer';
import worksheet from './components/worksheet/reducers/worksheetReducer';
import workshopReducer from './hub/reducers/workshopReducer';
import yearbookReducer from './yearbook/redux/yearbookReducer';
import zoomBoomReducer from './zoomBoom/redux/zoomBoomReducer';

// Middleware
import SearchlightMiddleware from './middleware/SearchlightMiddleware';
import PersistStateMiddleware from './middleware/PersistStateMiddleware';
import XApiMiddleware from './middleware/XApiMiddleware';
import ProgressTrackerMiddleware from './middleware/ProgressTrackerMiddleware';

const composeEnhancer = Env.isProd ? compose : composeWithDevTools;

const store = createStore(
  combineReducers({
    a11yPrototypeReducer,
    allAboardReducer,
    appSessionReducer,
    assignmentLink: assignmentLinkReducer,
    becauseThisThatReducer,
    bestBuddy,
    bigIdea: bigIdeaReducer,
    blending: blendingReducer,
    bookClub: bookClubReducer,
    boostFluency: boostFluencyReducer,
    captions,
    cartoonFactory: cartoonFactoryReducer,
    cityPlanner: cityPlannerReducer,
    codex: codexReducer,
    connectIt: connectItReducer,
    curiosoCallingReducer,
    curiosoCrossingReducer,
    curiosoReducer,
    curiousCases,
    curriculums: curriculumsReducer,
    cutItOutReducer,
    debateABall,
    directorsCut: directorsCutReducer,
    doubleTrouble: doubleTroubleReducer,
    eReader,
    estaOAquellaReducer,
    featureToggle: featureToggleReducer,
    fieldObserver,
    fluencyReducer,
    foodTruck: foodTruckCombinedReducers,
    fotoFotoCognado,
    gameHeader: gameHeaderReducer,
    gemNyeFriends: gemNyeFriendsReducer,
    globalErrorReducer,
    goblinGourmet,
    grumpyGoblinsReducer,
    hangryGoblinsReducer,
    idiomatica: idiomaticaReducer,
    inkBlottJrReducer,
    itemsReducer,
    juegaYConjuga: juegaYConjugaReducer,
    laRanaBrincacharcos,
    letterSoundCorrespondeces: letterSoundCorrecpondencesReducer,
    mapReducer,
    messageInABottle: messageInABottleReducer,
    metaGameReducer,
    mindTheGapReducer,
    modalSystem: modalSystemReducer,
    newGameReducer,
    newsFlash: newsFlashReducer,
    notebookReducer,
    parrotTheaterReducer,
    persistStateReducer,
    persistTestReducer,
    pickyGoblins: pickyGoblinsReducer,
    pictureThisReducer,
    placementTool,
    planTorres,
    poetsPathReducer,
    powerReducer,
    progressScreen: progressScreenReducer,
    punchlineReducers,
    questNavigationReducer,
    questWorkflowReducer,
    readAllAboutIt,
    realWordReading: realWordReadingReducer,
    regionMessages: liveRegionReducer,
    rhymeTime: rhymeTimeReducer,
    robovoicePrototypeReducer,
    robovoiceReducer,
    segmenting: segmentingReducer,
    selectedActivity: selectedActivityReducer,
    shadesOfMeaningReducer,
    showOffReducer,
    silabalonLaCopaReducer,
    silabalonReducer,
    skillScan,
    sloppyScrolls: sloppyScrollsCombinedReducers,
    sortingReducer,
    stickerBook: stickerBookReducer,
    storyboard: storyboardReducer,
    storyboxReducer,
    studentProgress: studentProgressReducer,
    superMatchReducer,
    syllableDecoding: syllableDecodingReducer,
    tfeReducer,
    tongueTwist: tongueTwistReducer,
    tubeTales: tubeTalesReducer,
    unmaskThat: unmaskThatCombinedReducers,
    usage: usageReducer,
    wildPlanet: wildPlanetReducer,
    wordbotsReducers,
    wordCity,
    wordRaiders: wordRaidersReducer,
    wordSlide: wordSlideReducer,
    worksheet,
    workshopReducer,
    yearbook: yearbookReducer,
    zoomBoom: zoomBoomReducer,
  }),
  {},
  composeEnhancer(
    applyMiddleware(
      thunk,
      SearchlightMiddleware,
      PersistStateMiddleware,
      XApiMiddleware,
      ProgressTrackerMiddleware,
    ),
  ),
);

export default store;
